/* Endurrad — hero «Cruscotto»: contagiri collegato al selettore marca/modello.
   File aggiunto: sopravvive agli aggiornamenti del tema. Caricato da sections/erd-hero-cruscotto.liquid. */
(function () {
  var root = document.querySelector('[data-erd-cru]');
  if (!root) return;
  var MAX = parseFloat(root.getAttribute('data-max')) || 80;
  var TOT = root.getAttribute('data-totale') || '';
  var FONTE = '/pages/contatti?view=moto-dati';
  var KEY = 'erd_moto_sel';
  var arc = root.querySelector('[data-cru-arc]');
  var needle = root.querySelector('[data-cru-needle]');
  var ticks = root.querySelectorAll('.erd-cru__tick');
  var num = root.querySelector('[data-cru-num]');
  var lab = root.querySelector('[data-cru-label]');
  var L = 586.43;
  var lento = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var timer = null, mappa = null, inCarico = null, richiesta = 0;

  /* Conteggi: stessi dati del selettore (templates/page.moto-dati.liquid, campo n) */
  function pagina(p, acc) {
    return fetch(FONTE + '&page=' + p, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        acc = acc.concat(d.voci || []);
        if (p < (d.pagine || 1) && p < 10) return pagina(p + 1, acc);
        return acc;
      });
  }
  function carica() {
    if (!inCarico) {
      inCarico = pagina(1, []).then(function (voci) {
        mappa = {};
        voci.forEach(function (v) {
          if (!v.marca || !v.base) return;
          var k = String(v.marca).trim() + '|' + String(v.base).trim();
          (mappa[k] = mappa[k] || []).push(v);
        });
      }).catch(function () { mappa = {}; });
    }
    return inCarico;
  }
  function conteggio(marca, base) {
    var g = (mappa || {})[marca + '|' + base] || [];
    if (!g.length) return null;
    var u = g[0].u;
    if (!u || !g.every(function (x) { return x.u === u; })) return null;
    return typeof g[0].n === 'number' ? g[0].n : null;
  }

  function lancetta(v) {
    needle.style.transform = 'rotate(' + (-120 + 240 * v).toFixed(1) + 'deg)';
    arc.style.strokeDashoffset = (L * (1 - v)).toFixed(1);
    for (var i = 0; i < ticks.length; i++) ticks[i].classList.toggle('is-on', i / (ticks.length - 1) <= v + 0.001);
  }
  function conta(fino) {
    if (timer) cancelAnimationFrame(timer);
    if (!lento) { num.textContent = String(fino); return; }
    var da = parseInt(num.textContent, 10);
    if (isNaN(da)) da = 0;
    var t0 = null;
    function passo(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / 700);
      num.textContent = String(Math.round(da + (fino - da) * (1 - Math.pow(1 - k, 3))));
      if (k < 1) timer = requestAnimationFrame(passo);
    }
    timer = requestAnimationFrame(passo);
  }
  function pulsante(testo) {
    var go = root.querySelector('.erd-hms__go');
    if (go) go.innerHTML = testo + ' <span aria-hidden="true">&rarr;</span>';
  }
  /* A riposo (moto non scelta): invito a scegliere, lancetta al minimo */
  var RIP_NUM = root.getAttribute('data-riposo-num') || '?';
  var RIP_LAB = root.getAttribute('data-riposo-label') || 'Che moto guidi?';
  function riposo() {
    if (timer) cancelAnimationFrame(timer);
    num.textContent = RIP_NUM;
    lab.textContent = RIP_LAB;
    lancetta(0.04);
    pulsante('Vedi accessori');
  }
  /* «Sgasata» all'apertura: la lancetta sale e torna al minimo */
  function sgasata() {
    if (!lento) { riposo(); return; }
    num.textContent = RIP_NUM;
    lab.textContent = RIP_LAB;
    lancetta(0.85);
    setTimeout(function () { if (!richiesta) riposo(); }, 750);
  }
  function mostra(marca, base) {
    var id = ++richiesta;
    if (!marca || !base) { riposo(); return; }
    carica().then(function () {
      if (id !== richiesta) return;
      var n = conteggio(marca, base);
      if (typeof n === 'number') {
        conta(n);
        lab.textContent = n === 1 ? 'Accessorio compatibile' : 'Accessori compatibili';
        lancetta(Math.max(0.02, Math.min(1, n / MAX)));
        pulsante('Vai ai ' + n + ' accessori');
      } else {
        if (timer) cancelAnimationFrame(timer);
        num.textContent = '✓';
        lab.textContent = marca + ' ' + base;
        lancetta(0.5);
        pulsante('Vedi accessori');
      }
    });
  }

  /* Ascolta il selettore (snippet erd-hero-moto-select) senza modificarlo */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) return;
    if (t.matches('[data-hms-marca]')) mostra('', '');
    else if (t.matches('[data-hms-modello]')) {
      var m = root.querySelector('[data-hms-marca]');
      mostra(m ? m.value : '', t.value);
    }
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-hms-clear]')) mostra('', '');
  });

  arc.style.strokeDasharray = L;
  arc.style.strokeDashoffset = L;
  lancetta(0);
  var salvata = null;
  try { salvata = JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) {}
  requestAnimationFrame(function () {
    if (salvata && salvata.marca && salvata.base) mostra(salvata.marca, salvata.base); else sgasata();
  });
})();
